import { type Validator } from "@redotech/ui/validator";
import { nonEmptyValidator } from "@redotech/ui/validators";

export const canadaPostApiKeyValidator: Validator<string> = (value) => {
  const requiredErrors = nonEmptyValidator(value);
  if (requiredErrors.length > 0) {
    return requiredErrors;
  }

  const apiKey = value.trim();
  const apiKeySeparatorIndex = apiKey.indexOf(":");
  if (apiKeySeparatorIndex <= 0 || apiKeySeparatorIndex === apiKey.length - 1) {
    return ["Enter the API key in username:password format"];
  }

  return [];
};
